export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4611.1ffd6b07.jpg";